import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
function toDate(value) {
  if (typeof value == 'string') {
    if (isNaN(Date.parse(value))) return false;
    return new Date(value);
  }
  if (!(value instanceof Date) || isNaN(value.getTime())) return false;
  return value;
}
export var useEventStore = defineStore({
  id: 'event',
  state: function state() {
    return {
      slug: null,
      event: {},
      card: null,
      module: {},
      accesses: null,
      hydrated: false,
      hydrating: false
    };
  },
  getters: {
    eventState: function eventState(state) {
      var _state$event, _state$module, _state$module$lection, _state$event2, _state$event3;
      // No start date, event in early stages of planning
      if (!(state !== null && state !== void 0 && (_state$event = state.event) !== null && _state$event !== void 0 && _state$event.startDate)) return 'upcoming';
      var now = new Date();
      var start = toDate(state.event.startDate);

      // Invalid start date, assume event in future
      if (!start) return 'upcoming';
      var hours = Math.round((start - now) / 1000 / 60 / 60);
      if (hours > 24) return 'upcoming';
      if (hours > 0) return 'coutdown';

      // Do video check before end date check, since video means event finished
      var video = (state === null || state === void 0 ? void 0 : (_state$module = state.module) === null || _state$module === void 0 ? void 0 : (_state$module$lection = _state$module.lections) === null || _state$module$lection === void 0 ? void 0 : _state$module$lection.length) && state.module.lections[0];
      if (video) return 'video';
      var end = toDate(state === null || state === void 0 ? void 0 : (_state$event2 = state.event) === null || _state$event2 === void 0 ? void 0 : _state$event2.endDate);
      if (!end) {
        // No end date, assume event takes 24 hours
        end = new Date(start);
        end.setDate(end.getDate() + 1);
      }
      if (now <= end) return 'ongoing';
      if (state !== null && state !== void 0 && (_state$event3 = state.event) !== null && _state$event3 !== void 0 && _state$event3.recordingPending) return 'editing';
      return 'finished';
    },
    type: function type(state) {
      var _state$module2;
      if (state !== null && state !== void 0 && (_state$module2 = state.module) !== null && _state$module2 !== void 0 && _state$module2.type) {
        var type = state.module.type;
        if (type == 'practice') return 'workshop';
        if (type == 'theory') return 'lecture';
      }
      return 'event';
    }
  },
  actions: {
    hydrate: function hydrate(slug) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this.hydrating) {
                _this.hydrating = new Promise(/*#__PURE__*/function () {
                  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
                    var _data$modules;
                    var data;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this.$nuxt.$axios.$get("/course/get", {
                            params: {
                              slug: slug
                            },
                            progress: false
                          }).catch(function (error) {
                            return reject(error);
                          });
                        case 2:
                          data = _context.sent;
                          _this.slug = slug;
                          _this.event = (data === null || data === void 0 ? void 0 : data.course) || {};
                          _this.module = (data === null || data === void 0 ? void 0 : (_data$modules = data.modules) === null || _data$modules === void 0 ? void 0 : _data$modules.length) && data.modules[0] || {};
                          _this.card = data === null || data === void 0 ? void 0 : data.card;
                          _this.accesses = data === null || data === void 0 ? void 0 : data.accesses;
                          _this.hydrated = true;
                          _this.hydrating = false;
                          return _context.abrupt("return", resolve(true));
                        case 11:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }
              return _context2.abrupt("return", _this.hydrating);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
});